<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-02-17                                                         -
  ----------------------------------------------------------------------------->

<template>
  <b-modal ref="modal_form"
           size="lg"
           centered
           :hide-header="noHeader"
           hide-footer>
    <template #modal-header v-if="!noHeader">
      <slot name="header"></slot>
    </template>
    <b-form v-on:input="handleInput" v-on:change="handleInput" novalidate validated>
      <slot name="fields" v-bind:item="localItem"></slot>

      <b-button v-if="isNew" :disabled="isInvalid || !isDirty" variant="primary" class="mr-1" @click="save">Save</b-button>
      <b-button v-if="!isNew" :disabled="isInvalid || !isDirty" variant="primary" class="mr-1" @click="update">Update</b-button>
      <b-button variant="outline-secondary" class="mr-1" @click="cancel()">Cancel</b-button>
      <b-button v-if="!isNew && !isDirty" variant="link" class="mr-1" @click="destroy()">Delete</b-button>
      <b-button v-if="isDirty" variant="link" class="mr-1" :disabled="!isDirty" @click="reset()">Reset</b-button>
    </b-form>
  </b-modal>

</template>

<script>
export default {
  name: "yega1-modal-upload-form",
  inject:{
    registerImportDialog: 'registerImportDialog',
    handleImportCompleted: 'handleImportCompleted'
  },
  data(){
    return{
      originalItem:{},
      localItem:{},
      isDirty:false,
      isInvalid:false,
      isNew:false
    }
  },
  props:{
    noHeader:Boolean,
    storeName:String
  },
  created(){
    this.registerImportDialog(this);
  },
  methods:{
    handleInput(event){
      this.isInvalid = false;
      for(let i=0; i < event.currentTarget.elements.length;i++){
        let element = event.currentTarget.elements[i];
        if(element.validity && !element.validity.valid){
          this.isInvalid = true;
        }
      }
      this.isDirty = true;
    },
    initializeItem(item){
      this.originalItem   = item;
      this.localItem      = Object.assign({}, this.originalItem);
      this.isDirty        = false;
    },
    save(){
      const that = this;
      let formData = new FormData();
      for (const property in this.localItem) {
        formData.append(property, this.localItem[property]);
      }
      let temp_item = {
        id:this.localItem.id,
        formData:formData
      };
      this.$store
          .dispatch(`${this.storeName}/upload`, temp_item)
          .then((savedItem)=>{
            this.initializeItem(savedItem);
            this.handleImportCompleted();
            that.$emit('item-saved',savedItem);
            this.$refs.modal_form.hide();
          })
          .catch((error)=>{
            that.$refs.modal_form.show();
            alert(error.response ? error.response.data : error);
          });
    },
    update(){
      const that = this;
      this.$store
          .dispatch(`${this.storeName}/update`, this.localItem)
          .then((updatedItem)=>{
            this.initializeItem(updatedItem);
            that.$emit('item-updated',updatedItem);
            this.$refs.modal_form.hide();
          })
          .catch((error)=>{
            that.$refs.modal_form.show();
            alert(error.response ? error.response.data : error);
          });
    },
    reset(){
      this.localItem = Object.assign({}, this.originalItem);
      this.isDirty = false;
    },
    cancel(){
      this.$refs.modal_form.hide();
    },
    destroy(){
      if(!confirm('Are you sure you would like to delete?')){
        return;
      }
      const that = this;
      this.$store
          .dispatch(`${this.storeName}/destroy`, this.localItem.id)
          .then(()=>{
            that.$emit('item-destroyed');
          })
          .catch((error)=>{alert(error.response ? error.response.data : error);});
    },
    newItem(item_template){
      const that = this;
      let initial_item = {...item_template,attribute_store:{}};
      this.$store.dispatch(`${this.storeName}/initialize`, initial_item)
          .then((initializedItem)=>{
            that.initializeItem(initializedItem);
            that.$emit('item-initialized',this.localItem);
            that.isNew= true;
            that.$refs.modal_form.show();
          })
          .catch((error)=>{alert(error.response ? error.response.data : error);});
    },
    loadItem(id){
      const that = this;
      this.$store.dispatch(`${this.storeName}/show`, id)
          .then((loadedItem)=>{
            that.initializeItem(loadedItem);
            that.$emit('item-loaded',loadedItem);
            that.isNew= false;
            that.$refs.modal_form.show();
          })
          .catch((error)=>{alert(error.response ? error.response.data : error);});
    }
  }
}
</script>

<style scoped>

</style>
